let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dX2gb")).then(() => parcelRequire('dA2b2'));